module.exports = __webpack_public_path__ + "static/media/kenjac.4d72b4b9.png";